import { useContext } from "react";

import { getServiceConfig } from "@/common/serviceConfigurations";
import { Permission } from "@/components/UserManagement/types";
import { userPermissionChecks } from "@/components/UserManagement/utils";
import { AuthStateContext } from "@/contexts/AuthContext";
import { useDevEnvironment } from "@/contexts/DevContext";

export type RubiMessageAccess = "user" | "org" | "none";

// Mirrors the RubiMESSAGE checks in AppSelector.
export const useRubiMessageAccess = (): RubiMessageAccess => {
  const { currentUser } = useContext(AuthStateContext);
  const { isDevEnv } = useDevEnvironment();

  const currentUserPermissions =
    currentUser?.permissions?.map((permission) => permission.title) || [];
  const userPermissions = userPermissionChecks(currentUserPermissions);
  const organizationAppPermissions =
    getServiceConfig(currentUser?.rubi_org_id ?? "NA", isDevEnv)?.apps ?? [];

  if (!organizationAppPermissions.includes(Permission.MESSAGE)) {
    return "none";
  }
  return userPermissions.canAccessMessageApp ? "user" : "org";
};
